import {
  Colors,
  Cross,
  Modal,
  ShareIcon,
  ShareIconWrap,
  Typography
} from '@giantleap/components-library'
import * as mixpanel from 'mixpanel-browser'
import * as React from 'react'
import { _route } from '../../routes/config'
import ISocialLink from './ISocialLink'
import links from './links'
import styles from './style.module.scss'

interface IProps {
  user: any
  open: boolean
  onClose: () => void
}

interface IState {}

class ShareModal extends React.Component<IProps, IState> {
  onShareClicked = socialType => {
    mixpanel.identify(this.props.user.uid)
    mixpanel.track('Shared', {
      type: socialType
    })
  }

  setActive = (status: boolean) => {
    if (!status) {
      const { onClose } = this.props
      onClose()
    }
  }

  render() {
    const { open } = this.props
    return (
      <Modal
        active={open}
        setActive={this.setActive}
        baseClassName={styles.wrap}
        x={<Cross size="big" color={Colors.unselected} />}
      >
        <Typography type="title" size="big">
          We appreciate your support
          <span style={{ color: Colors.redAccent, fontStyle: 'italic' }}>
            !
          </span>
        </Typography>
        <Typography type="text">
          The share message will not disclose any of your child’s personal
          information
        </Typography>
        <ShareIconWrap>
          {links.map((link: ISocialLink, i: number) => {
            const { Wrapper, url, type, socialType, otherProps } = link

            return (
              <React.Fragment key={i}>
                <Wrapper key={i} url={url} {...otherProps}>
                  <ShareIcon
                    type={type}
                    onClick={() => this.onShareClicked(socialType)}
                  />
                </Wrapper>
              </React.Fragment>
            )
          })}
        </ShareIconWrap>
      </Modal>
    )
  }
}

export default ShareModal



// WEBPACK FOOTER //
// ./src/components/ShareModal/index.tsx